import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Grid, Loader, Header, Segment} from 'semantic-ui-react';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {TEAM_MANAGE} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {Toggle} from 'componentLibrary';
import {isAnalyticsAdmin, canViewTeamPage} from 'go/security/permissions';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
class OrgUsersCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: this.props.userData,
      error: '',
      lastAORS: [{}],
      loading: true,
    };
  }

  componentDidMount() {
    document.title = TEAM_MANAGE;
    this.setState({
      users: this.props.userData,
    });
  }

  UNSAFE_componentWillReceiveProps(props, state) {
    if (props.userData.length > 0) {
      this.setState({
        users: props.userData,
        lastAORs: this.fetchAllLastAOR(props.userData, props.entities),
        loading: false,
      });
    }
  }

  handleRemoveClick = async (selectedUser) => {
    try {
      let res = await this.props.removeSelectedRole(
        selectedUser.userId,
        selectedUser.entity.entityId,
        selectedUser.role.roleId,
        selectedUser.entityType.entiyTypeId
      );
      if (res.ok) {
        this.props.toggleModal('remove');
        this.props.reloadUserList();
      }
    } catch (e) {
      this.setState({
        error: 'Failed to process your request',
      });
    }
  };

  includesLastAOR = (user, lastAORs) => {
    if (lastAORs !== [{}]) {
      return false;
    }
    return !_.includes(Object.values(lastAORs), user);
  };

  fetchAllLastAOR = (users, entities) => {
    let count = [];
    let lastAOR = {};

    if (!_.isEmpty(users)) {
      _.forEach(entities, (entity) => {
        _.forEach(users, (user) => {
          if (user.entity.entityId === entity.entityId) {
            if (user.role.roleId === 1) {
              lastAOR[entity.displayName] = user;
              if (count[entity.displayName] !== undefined) {
                count[entity.displayName]++;
                if (count[entity.displayName] === 2) {
                  lastAOR[entity.displayName] = {};
                  return false;
                }
              } else {
                count[entity.displayName] = 1;
              }
            }
          }
        });
      });
    }
    return lastAOR;
  };

  isLoggedInAOR = (user) => {
    if (user.userId === this.props.userId && user.role.roleId === 1) {
      return true;
    }
    return false;
  };

  isAnalyticsEntityType = (user) => {
    return user.entityType.entiyTypeId == ENTITY_MAP.REPORT_CATEGORY.code;
  };

  render() {
    const {users, lastAORs} = this.state;
    const {selectedUser, permissions, numEntityRoles, userId} = this.props;
    return (
      <React.Fragment>
        {!this.props.loading ? (
          <React.Fragment>
            <FemaGoModal
              title="Confirm Role Deletion"
              type="alert"
              size="tiny"
              open={this.props.removeModalVisible}
              buttonText="Remove role"
              confirmAction={(e) => this.handleRemoveClick(selectedUser)}
              cancelAction={() => this.props.toggleModal('remove')}
            >
              Please confirm deletion for the selected recipient's role:
              <br />
              <strong>User:</strong> {selectedUser && selectedUser.userId}
              <br />
              <strong>Role:</strong> {selectedUser && selectedUser.role.description}
              <br />
              <strong>Organization:</strong>{' '}
              {selectedUser && selectedUser.entity && selectedUser.entity.displayName}
            </FemaGoModal>
            <Grid verticalAlign="bottom" columns="3">
              <Grid.Row>
                <Grid.Column floated="left" width="9">
                  <Header as="h1">Manage Your Team</Header>
                </Grid.Column>
                <Toggle toggle="manageTeamWithAnalyticsAdmin">
                  {isAnalyticsAdmin(permissions) && (
                    <Grid.Column width="4">
                      <Button
                        size="medium"
                        rounded="true"
                        content="Add Analytics Team Member"
                        primary
                        onClick={() => this.props.toggleModal('addAnalytics')}
                      />
                    </Grid.Column>
                  )}
                </Toggle>
                {canViewTeamPage(permissions) && (
                  <Grid.Column floated="right" width="3">
                    <Button
                      size="medium"
                      rounded="true"
                      content="Add Team Member"
                      primary
                      onClick={() => this.props.toggleModal('add')}
                    />
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
            <Segment>
              <FemaGoTable type="static" summary="Manage your team">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Email</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Organization</FemaGoTable.HeaderCell>
                    <Toggle toggle="manageTeamWithAnalyticsAdmin">
                      {isAnalyticsAdmin(permissions) ? (
                        <FemaGoTable.HeaderCell>Report Category</FemaGoTable.HeaderCell>
                      ) : (
                        <FemaGoTable.HeaderCell />
                      )}
                    </Toggle>
                    <FemaGoTable.HeaderCell>Role</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Actions</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body divided="true">
                  {users.map((user) => {
                    let userEntityId = user.entity.entityId;
                    let userRoleId = user.role.roleId;
                    let numRoles = _.get(numEntityRoles, `${userEntityId}.${userRoleId}`);
                    let isLastRole = numRoles === undefined || numRoles <= 1;
                    let isCurrentUser = user.userId === userId;
                    return (
                      <FemaGoTable.Row
                        key={
                          user.userId + user.entity.displayName + user.role.description
                        }
                      >
                        <FemaGoTable.TextCell>{user.userId}</FemaGoTable.TextCell>
                        {!this.isAnalyticsEntityType(user) ? (
                          <FemaGoTable.TextCell>
                            {user.entity.displayName}
                          </FemaGoTable.TextCell>
                        ) : (
                          <FemaGoTable.TextCell />
                        )}
                        <Toggle toggle="manageTeamWithAnalyticsAdmin">
                          {isAnalyticsAdmin(permissions) &&
                          this.isAnalyticsEntityType(user) ? (
                            <FemaGoTable.TextCell>
                              {user.entity.displayName}
                            </FemaGoTable.TextCell>
                          ) : (
                            <FemaGoTable.TextCell />
                          )}
                        </Toggle>
                        <FemaGoTable.TextCell>
                          {user.role.description}
                        </FemaGoTable.TextCell>
                        {!this.includesLastAOR(user, lastAORs) &&
                          !this.isLoggedInAOR(user) && (
                            <FemaGoTable.DeleteCell
                              disabled={isLastRole || isCurrentUser}
                              name={`Remove role ${user.role.description} from ${user.userId} in ${user.entity.displayName}`}
                              handleChange={(e, data) => {
                                e.preventDefault();
                                this.props.openRemoveModal(user);
                              }}
                              handleBlur={() => {}}
                            />
                          )}
                      </FemaGoTable.Row>
                    );
                  })}
                </FemaGoTable.Body>
              </FemaGoTable>
            </Segment>
          </React.Fragment>
        ) : (
          <Loader active>Loading...</Loader>
        )}
      </React.Fragment>
    );
  }
}

const mapsStateToProps = (state) => {
  return {
    permissions: state.auth.permissions,
  };
};

// export default OrgUsersCard;
export default connect(mapsStateToProps)(OrgUsersCard);
